import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CLOCK: GlameraIconDefinition = {
  name: 'clock',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-clock-minute" d="M12 12V6"></path>
    <path class="glm-clock-hour" d="M12 12l4 2"></path>
    <circle class="glm-clock-face" cx="12" cy="12" r="10"></circle>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-clock-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './clock.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ClockIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CLOCK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
